module.exports = __webpack_public_path__ + "static/media/sample20.0d5e7000.jpg";